var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 107,
    viewBox: "0 0 98 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_104_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4883 21.6266C29.8082 18.418 25.8078 17.1421 22.8841 19.2797C17.8821 22.9368 13.6877 27.6241 10.5998 33.0527C7.51186 38.4814 5.62673 44.4822 5.03975 50.6506C4.69665 54.2562 7.83797 57.0426 11.4545 56.8468C15.0711 56.651 17.7729 53.5321 18.343 49.9554C18.9243 46.3088 20.1571 42.778 22.0003 39.5376C23.8436 36.2971 26.2483 33.433 29.0856 31.0696C31.8684 28.7516 33.1684 24.8352 31.4883 21.6266Z",
    fill: "url(#paint0_linear_104_2284)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_104_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0148 21.223C66.6299 17.862 70.7024 16.4066 73.7772 18.5161C78.9792 22.085 83.3762 26.7462 86.644 32.2038C89.9117 37.6614 91.9442 43.7382 92.6337 50.0091C93.0413 53.7156 89.8352 56.6182 86.11 56.4548C82.3847 56.2914 79.5732 53.1062 78.9153 49.4359C78.2667 45.8171 76.9662 42.3266 75.0586 39.1405C73.1509 35.9545 70.6882 33.16 67.8045 30.8793C64.8798 28.5663 63.3998 24.5839 65.0148 21.223Z",
    fill: "url(#paint1_linear_104_2284)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_104_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8046 88.342C71.6789 91.1692 70.9199 95.0245 67.8595 96.4875C61.8501 99.3604 55.2414 100.844 48.5275 100.792C41.8136 100.74 35.2288 99.1535 29.2648 96.1876C26.2276 94.6772 25.5285 90.8105 27.4466 88.0128C29.3647 85.2152 33.1744 84.5658 36.2887 85.9101C40.1663 87.5839 44.3586 88.4755 48.623 88.5086C52.8874 88.5418 57.093 87.7155 60.9962 86.1021C64.131 84.8063 67.9302 85.5149 69.8046 88.342Z",
    fill: "url(#paint2_linear_104_2284)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_104_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.66 32.8933C49.1099 31.681 54.8027 32.4069 59.7928 34.949C64.7828 37.4911 68.7707 41.6969 71.0936 46.8689C72.64 50.3121 73.3847 54.0458 73.3065 57.784C67.9192 60.1025 64.1474 65.4589 64.1473 71.6961C64.1473 73.2454 64.3799 74.7406 64.8124 76.1482C64.4042 76.5064 63.9843 76.8528 63.5516 77.1843C59.0919 80.6012 53.6205 82.3594 48.0458 82.1677C44.7675 82.055 41.5691 81.2721 38.6317 79.8904C35.1767 78.2652 34.8772 73.7961 37.3426 70.8806C39.8771 67.8839 44.59 67.902 48.5125 68.0369C50.9255 68.1199 53.2941 67.3586 55.2245 65.8797C57.1549 64.4006 58.5311 62.2919 59.1249 59.9051C59.7186 57.5183 59.4946 54.9963 58.4891 52.7576C57.4836 50.5188 55.7575 48.6978 53.5975 47.5974C51.4375 46.4971 48.9731 46.184 46.6141 46.7088C44.2553 47.2336 42.1431 48.5655 40.6288 50.4832C40.5534 50.5786 40.48 50.6755 40.4081 50.7732C38.1387 53.8562 35.1854 57.2515 31.3573 57.2517C27.5289 57.2517 24.3327 54.0916 25.3651 50.4051C26.2566 47.2216 27.7672 44.2286 29.8319 41.614C33.3307 37.1833 38.2101 34.1058 43.66 32.8933Z",
    fill: "url(#paint3_linear_104_2284)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_104_2284)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.7169,
    cy: 73.2237,
    rx: 12.5694,
    ry: 12.5694,
    fill: "url(#paint4_linear_104_2284)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_104_2284)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7442,
    cy: 73.2237,
    rx: 12.5694,
    ry: 12.5694,
    fill: "url(#paint5_linear_104_2284)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_104_2284)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9669,
    cy: 13.3629,
    rx: 12.5694,
    ry: 12.5694,
    fill: "url(#paint6_linear_104_2284)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_104_2284",
    x: 1.83907,
    y: 17.4314,
    width: 33.5719,
    height: 44.9806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_104_2284",
    x: 61.175,
    y: 16.7381,
    width: 34.6685,
    height: 45.2789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_104_2284",
    x: 23.2033,
    y: 84.4422,
    width: 50.7916,
    height: 21.9068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_104_2284",
    x: 21.9943,
    y: 31.5272,
    width: 54.4928,
    height: 56.2105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_104_2284",
    x: 65.9729,
    y: 59.8606,
    width: 31.4879,
    height: 31.4879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_104_2284",
    x: 0.000201464,
    y: 59.8606,
    width: 31.4879,
    height: 31.4879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_104_2284",
    x: 32.2229,
    y: -0.000193596,
    width: 31.4879,
    height: 31.4879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_2284",
    x1: 4.8418,
    y1: 10.7935,
    x2: 38.9916,
    y2: 171.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_104_2284",
    x1: 92.8975,
    y1: 10.7935,
    x2: 58.7477,
    y2: 171.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_104_2284",
    x1: 92.8975,
    y1: 12.7378,
    x2: 58.7477,
    y2: 173.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_104_2284",
    x1: 25.1689,
    y1: 32.3208,
    x2: 45.1334,
    y2: 122.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_104_2284",
    x1: 69.1475,
    y1: 60.6543,
    x2: 78.8968,
    y2: 106.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_104_2284",
    x1: 3.1748,
    y1: 60.6543,
    x2: 12.9242,
    y2: 106.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_104_2284",
    x1: 35.3975,
    y1: 0.793457,
    x2: 45.1468,
    y2: 46.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9742FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E22FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoginLogo);
export default __webpack_public_path__ + "static/media/ic_login_logo.332bd6b782e771ddf2560f66ab293467.svg";
export { ForwardRef as ReactComponent };